import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, handleResponse, toQueryString } from '../utils';
import {
  InvoicesQueryParams,
  InvoicesResponse,
  MarkMerchantInvoiceAsPaidRequest,
  SendLatestMerchantInvoiceEmailRequest,
} from './invoices.types';

export const getInvoices = async (
  apiAprilBaseUri: string,
  queryParams: InvoicesQueryParams,
): Promise<PaginatedResponse<InvoicesResponse>> => {
  let qParams = toQueryString(queryParams, ['status']);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/transactions/invoices${qParams}`, options).then(handlePaginatedResponse);
};

export const admininsterInvoice = async (
  apiAprilBaseUri: string,
  invoiceId: string,
  payload: SendLatestMerchantInvoiceEmailRequest | MarkMerchantInvoiceAsPaidRequest,
): Promise<object> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/transactions/enterprise/invoices/${invoiceId}`, options).then(handleResponse);
};

export const downloadInvoicePdf = async (apiAprilBaseUri: string, invoiceId: string): Promise<string | null> => {
  const options = await getFetchOptions('GET');
  return await fetch(`${apiAprilBaseUri}/transactions/invoices/${invoiceId}/pdf`, options)
    .then((res) => {
      return res.blob();
    })
    .then((blob) => URL.createObjectURL(blob))
    .catch((err) => {
      return null;
    });
};
